import React from "react";

const TopProviders = ({ providers }) => {

    return (

        <div className="top-providers">

            <h3>Top Providers</h3>

            <table>

                <thead>

                    <tr>

                        <th>Provider</th>

                        <th>Revenue</th>

                        <th>Orders</th>

                    </tr>

                </thead>

                <tbody>

                    {providers.map((provider) => (

                        <tr key={provider._id}>

                            <td>{provider._id}</td>

                            <td>₹{provider.revenue}</td>

                            <td>{provider.orders}</td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

};

export default TopProviders;